/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GatewaySessionFacet = {
  label: string;
  value: string;
};

/** @internal */
export const GatewaySessionFacet$inboundSchema: z.ZodMiniType<
  GatewaySessionFacet,
  unknown
> = z.object({
  label: z.string(),
  value: z.string(),
});

export function gatewaySessionFacetFromJSON(
  jsonString: string,
): SafeParseResult<GatewaySessionFacet, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GatewaySessionFacet$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GatewaySessionFacet' from JSON`,
  );
}
